<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-container>
        <v-card-title class="headline px-0">
          {{ digitoryApp.id ? "Edit Application" : "Add Application" }}
        </v-card-title>
        <v-card-text class="px-2">
          <v-form
            ref="digitoryAppForm"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-select
                v-model="digitoryApp.app_type"
                label="App Type*"
                :items="appTypes"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="digitoryApp.version"
                label="Version*"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-select
                v-model="digitoryApp.platform"
                label="Platform/os*"
                :items="platforms"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="digitoryApp.file_Path"
                label="filePath*"
                required
                :rules="rules"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="digitoryApp.git_ref.branch"
                label="Branch"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="digitoryApp.git_ref.commit_id"
                label="Commit Id"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="digitoryApp.git_ref.tag"
                label="Tag"
                outlined
                dense
              />
            </v-flex>
            <v-flex>
              <v-textarea
                v-model="digitoryApp.notes"
                label="Notes"
                rows="2"
                outlined
                dense
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight: 400; margin-right: 4px">*indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            color="success"
            class="white--text"
            :disabled="!isValid"
            :loading="loader"
            @click.native="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { failure } from "@/mixins/common";
export default {
  name: "NewDigitoryApp",
  mixins: [failure],
  data() {
    return {
      dialog: false,
      digitoryApp: {
        id: null,
        version: null,
        app_type: null,
        platform: null,
        file_Path: null,
        git_ref: {
          branch: null,
          commit_id: null,
          tag: null
        },
        notes: null
      },
      appTypes: ["pos_engine", "pos", "kds", "kiosk"],
      platforms: ["android", "windows", "mac", "ios", "linux"],
      loader: false,
      isValid: false,
      rules: [v => !!v || "Field is required"]
    };
  },
  methods: {
    resetApp() {
      this.digitoryApp = {
        id: null,
        version: null,
        app_type: null,
        platform: null,
        file_Path: null,
        git_ref: {
          branch: null,
          commit_id: null,
          tag: null
        },
        notes: null
      };
      if (this.$refs.digitoryAppForm) {
        this.$refs.digitoryAppForm.resetValidation();
      }
    },
    open() {
      this.resetApp();
      this.dialog = true;
    },
    save() {
      if (!this.$refs.digitoryAppForm.validate()) {
        return;
      }
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/digitoryApps`;
      if (this.digitoryApp.id) {
        url += `/${this.appId}`;
        this.$http.put(url, this.digitoryApp).then(
          response => {
            this.loader = false;
            this.close();
            this.handleSuccess(response);
          },
          failure => {
            this.loader = false;
            this.handleFailure(failure);
          }
        );
        return;
      }
      this.$http.post(url, this.digitoryApp).then(
        response => {
          this.loader = false;
          this.close();
          this.handleSuccess(response);
        },
        failure => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    close() {
      this.dialog = false;
      this.resetApp();
      this.$emit("refresh");
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.body.message
      });
    }
  }
};
</script>
